<div class="row justify-content-center">
  <div class="col-12 col-lg-10 col-xl-8">
    <!-- Header -->
    <app-organization-header></app-organization-header>

    <div class="text-left">
      <h2>Employés</h2>
    </div>

    <hr>

    <app-employee-invite (inviteSent)="onInviteSent($event)"></app-employee-invite>

    <app-employee-invite-list #invitationList></app-employee-invite-list>

    <app-employee-list></app-employee-list>
  </div>
</div> <!-- / .row -->